import styled from 'styled-components';

export default styled.option`
    font-family: sans-serif;
    font-weight: bold;
    border: 0px;
    background-color: transparent;
    color: rgb(40, 40, 45);
`;



// WEBPACK FOOTER //
// ./src/styledSystem/Option.js